import { default as olScaleLine } from 'ol/control/ScaleLine.js';
import {Control} from '../Control.js';

export class ScaleLine extends Control {

    constructor( map, settings = {} ){
        settings['name'] = "scale_line";
        if( settings['target'] == undefined ) settings['target'] = "scale_line";
        if( settings['units'] == undefined ) settings['units'] = "us";
        super( map, settings );
        this.getState();

        this.control = new olScaleLine({
                "target": this.target,
                });
    }

}
